import { render, staticRenderFns } from "./CatalogoItens.vue?vue&type=template&id=f48a0bc6&scoped=true"
import script from "./CatalogoItens.vue?vue&type=script&lang=js"
export * from "./CatalogoItens.vue?vue&type=script&lang=js"
import style0 from "./CatalogoItens.vue?vue&type=style&index=0&id=f48a0bc6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a0bc6",
  null
  
)

export default component.exports